// @ts-strict-ignore
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { FloatingLabelSelect, Skeleton } from "@aviary";
import { usePractitionerTypesQuery } from "@shared/data/queries/PractitionerTypesQuery/PractitionerTypes.query";
import { l } from "@shared/locales/i18n";

interface Props {
  onChange: (e) => void;
  value: string;
  errors: string[];
}

const FieldOfStudySelect = ({ value = "", onChange, errors }: Props) => {
  const { t } = useTranslation();
  const { data: pracTypesData, loading: practTypeLoading } = usePractitionerTypesQuery();
  const validationInputRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    if (validationInputRef.current) {
      if (!value) {
        validationInputRef.current.setCustomValidity(
          t(l.sharedOnboarding.studentInfo.pleaseSelectFieldOfStudy)
        );
      } else {
        validationInputRef.current.setCustomValidity("");
      }
    }
  }, [value, t]);

  if (practTypeLoading || !pracTypesData) {
    return <Skeleton type="typography" typographySize="h1" isFullWidth />;
  }

  const { practitionerTypes } = pracTypesData;

  const renderStudentItems = () => {
    return practitionerTypes
      .filter(type => type.code !== "STU")
      .map(type => {
        return (
          <option key={type.id} value={type.id}>
            {type.description}
          </option>
        );
      });
  };

  return (
    <FloatingLabelSelect
      ref={validationInputRef}
      id="practitionerTypeId"
      name={t(l.sharedOnboarding.studentInfo.fieldOfStudy)}
      label={t(l.sharedOnboarding.studentInfo.fieldOfStudy)}
      handleChange={onChange}
      value={value}
      required
      errors={errors}
      data-e2e="field-of-study"
    >
      <option value="" key="" disabled>
        {t(l.sharedOnboarding.select)}
      </option>
      {renderStudentItems()}
    </FloatingLabelSelect>
  );
};

export { FieldOfStudySelect };
